import { Component } from 'react';
import { UniGrid } from '../UniGrid';
import { ButtonItem, ButtonOptions, EmptyItem, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import PrepareAuxFile, { AuxFile } from './AuxFile';
import SideDivider from '../layout/SideDivider';
import ViewDocuments from './ViewDocuments';
import MasterLayout from '../layout/MasterLayout';
import { formatNumber } from 'devextreme/localization';
import CarPlate from '../utils/CarPlate';
import Inline from '../Inline';
import { Button, List, Popup, SelectBox } from 'devextreme-react';
import { NumberBox, Button as NbButton } from 'devextreme-react/number-box';
import { apiDeleteA, apiGetA, apiPostA, apiPostNoBodyA } from '../../GanjiTools';
import { Form } from 'devextreme-react/form';
import TarikhPicker from '../TarikhPicker';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import { isMobile } from 'react-device-detect';

class Missions extends Component {

    state = {
        lookups: {},
        focusedMission: null,
        focusedRowEnabled: true,
        viewDocumentsKey: 1,
        grdKey: 1,
    }

    onMissionSavedOrCanceled = (act, row) => {
        if (act == 'add') {
            this.state.focusedMission = row;
            this.state.grdKey++;
        }

        AuxFile.manageTemporariesA('Mission', act, this.state.focusedMission?.id)
            .then(_ => this.setState({ viewDocumentsKey: this.state.viewDocumentsKey + 1 }))
            .catch(window.notif);
    }

    saveMission = m => {
        //apiPostA('/api/dyna/saveRow/Mission', m)
        apiPostA('/api/parssaman/saveRow/Mission', m)
            .then(res => {
                let { error, row } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.state.focusedMission = row;
                this.state.popVisible = false;
                this.state.grdKey++;
                this.onMissionSavedOrCanceled('keep', row);
            })
            .catch(window.notif);
    }

    cancelSavingMission = m => {
        this.state.popVisible = false;
        this.onMissionSavedOrCanceled('remove', m);
    }

    static renderCurrencyCell(ci, displayIfNull = 0) {
        return (
            <span>{formatNumber(ci.value ?? displayIfNull)}</span>
        );
    }

    onEditMission = data => {
        this.setState({ popVisible: true });
    }

    onAddNewMission = () => {
        this.setState({ focusedMission: { id: -1 }, popVisible: true });
    }

    onDeleteMission = () => {
        if (!(this.state.focusedMission?.id > 0)) {
            window.notif('No row for delete.');
            return;
        }
        if (!confirm("واقعاً حذف شود؟"))
            return;

        apiDeleteA('/api/dyna/deleteRow/mission/' + this.state.focusedMission.id)
            .then(res => {
                const { error } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ grdKey: this.state.grdKey + 1 });
            }).catch(window.notif);
    }

    loadTableA = async (table, asLookup = true, nullDisplay) => {
        let res = (asLookup
            ? (await apiPostA(`/api/dyna/rowsAsLookup/${table}`, { wherePhrase: '' }))
            : (await apiPostA(`/api/dyna/rows_entt/${table}`, {}))
        ) ?? { error: 'No response.' };

        if (res.error?.length > 0)
            throw (res.error);

        let list = res[res._rows_key ?? 'list'] ?? [];

        if (nullDisplay?.length > 0)
            list = [{ id: null, summary: nullDisplay }, ...list];

        return list;
    }

    loadLookupsA = async whenDone => {
        this.state.lookups.truckOwners = await this.loadTableA('truckOwner');
        this.state.lookups.allTrucks = await this.loadTableA('taraTruck', false);
        this.state.lookups.drivers = await this.loadTableA('taraDriver');
        this.state.lookups.remittances = await this.loadTableA('remittance', false, '---');
        this.state.lookups.allMaterials = await this.loadTableA('material');
        this.state.lookups.tankers = await this.loadTableA('tanker');
        this.state.lookups.transitPoints = await this.loadTableA('transitPoint');
        this.state.lookups.customers = await this.loadTableA('customer');

        window.truckOwnersLookup = this.state.lookups.truckOwners;
        window.tankersLookup = this.state.lookups.tankers;
        window.customersLookup = this.state.lookups.customers;
        window.driversLookup = this.state.lookups.drivers;
        this.forceUpdate(whenDone);
    }

    componentDidMount() {
        this.loadLookupsA().then().catch(window.notif);
    }

    render() {
        let width = this.props.width ?? //(SideDivider.bodyWidth * 0.95) + 'px';
            (window.mView ? '95vw' : `calc(${Math.round(SideDivider.bodyWidth * 0.95)}px - 3rem)`);

        return (
            <>
                <UniGrid table='mission' dynaLoadheight={MasterLayout.bodyHeight - 150} readOnly
                    width={width} titleFontSize={window.mView ? '1rem' : '1.4rem'}
                    editFormProps={{ labelLocation: window.mView ? 'top' : 'left' }}
                    title='مأموریت ها'
                    pageSize={10}
                    key={'grd_' + this.state.grdKey}
                    //onDataLoaded={(_rows, cols) => console.log(cols)}
                    popupHeight='auto' //formColCount={2}
                    onFocusedRowChanged={focusedMission => this.setState({ focusedMission })}
                    focusedRowKey={this.state.focusedMission?.id}
                    //focusedRowKey={this.state.focusedMission?.id ?? 0}
                    onEditCanceled={() => this.onMissionSavedOrCanceled('remove')}
                    onSaved={(crud, row) => this.onMissionSavedOrCanceled(crud == 'insert' ? 'add' : 'keep', row)}

                    modifyFields={{
                        //totalfreight: { visible: false },
                        tankerfreight: { cellRender: Missions.renderCurrencyCell },
                        carfreight: { cellRender: Missions.renderCurrencyCell },
                        ladingbill: { cellRender: Missions.renderCurrencyCell },
                        phee: { cellRender: Missions.renderCurrencyCell },
                        profit: { cellRender: Missions.renderCurrencyCell },
                        fk_truck: {
                            caption: 'ماشین - صاحب ماشین',
                            width: '18em',
                            cellRender: (c, focused) => (
                                <Inline spacing='1em'>
                                    <CarPlate value={c.displayValue?.split(':')[1]} readOnly focused={focused} />
                                    <div>{c.displayValue?.split(':')[0]}</div>
                                </Inline>
                            )
                        }
                    }}

                    buttonColumns={!['ادمین', 'اپراتور'].includes(window.user.role) ? [] :
                        [
                            {
                                locateAtBefore: true, icon: '', width: '5em',
                                textOfRow: x => (
                                    <Inline spacing='0.7em'>
                                        <FontAwesomeIcon icon='trash' type='solid' fontSize='0.8em' onClick={() => this.onDeleteMission(x)} />
                                        <FontAwesomeIcon icon='pencil' type='solid' fontSize='0.8em' onClick={() => this.onEditMission(x)} />
                                    </Inline>
                                )
                            },
                        ]}

                    addToToolbar={<Button icon='plus' onClick={this.onAddNewMission} />}
                />

                <ViewDocuments table='mission' rowId={this.state.focusedMission?.id} width={width}
                    key={`view_doc_${this.state.focusedMission?.id ?? 0}_${this.state.viewDocumentsKey ?? 0}`}
                />

                <Popup visible={this.state.popVisible} rtlEnabled title='مأموریت'
                    width={window.mView ? '95vw' : (this.state.width ?? '75vw')} height={this.state.height ?? 'auto'}
                    key={'pop_' + (this.state.focusedMission?.id ?? '_')}
                    onHiding={() => this.setState({ popVisible: false })}
                    resizeEnabled={!isMobile} onResizeEnd={({ width, height }) => this.setState({ width, height })}
                >
                    <MissionForm mission={this.state.focusedMission} lookups={this.state.lookups} key={'fo_' + (this.state.focusedMission?.id ?? '_')}
                        onSave={m => this.saveMission(m)}
                        OnCancel={m => this.cancelSavingMission(m)}
                    />
                </Popup>
            </>
        );
    }
}

class MissionForm extends Component {
    state = {
        mission: this.props.mission ?? { id: 0 },
        ...this.props.lookups
    }

    renderPaymentUnitSelector = (value, onValueChanged) => {
        return (
            <SelectBox rtlEnabled valueExpr='id' displayExpr='summary'
                items={[
                    { id: 0, summary: 'به ازای هر تن' },
                    { id: 1, summary: 'به ازای هر سرویس' },
                ]}
                value={value}
                onValueChanged={e => onValueChanged(e.value)}
            />
        );
    }

    renderPaymentUnitButtons = (name, compact) => ([
        <NbButton key='pertone' name='pertone'
            options={{
                text: compact ? 'ت' : 'هر تن',
                type: this.state.mission[name] > 0 ? null : 'success',
                icon: window.mView ? null : this.state.mission[name] > 0 ? null : 'check',
                onClick: _ => {
                    this.state.mission[name] = 0;
                    this.forceUpdate();
                }
            }}
        />,
        <NbButton key='perservice' name='perservice'
            options={{
                text: compact ? 'س' : 'هر سرویس',
                type: this.state.mission[name] > 0 ? 'success' : null,
                icon: window.mView ? null : this.state.mission[name] > 0 ? 'check' : null,
                onClick: _ => {
                    this.state.mission[name] = 1;
                    this.forceUpdate();
                }
            }}
        />
    ]);

    componentDidMount() {
        let truck = this.state.mission?.fk_truck > 0 && (this.state.allTrucks?.find(x => x.id === this.state.mission.fk_truck));
        this.state.truckOwner = truck?.fK_Owner > 0 && (this.state.truckOwners?.find(x => x.id === truck.fK_Owner));
        this.state.trucks = truck?.fK_Owner > 0 && this.state.allTrucks?.filter(x => x.fK_Owner === truck.fK_Owner);
        if (this.state.trucks?.length === 1)
            this.state.mission.fk_truck = this.state.trucks[0]?.id;

        let remittance = this.state.mission.fk_remittance > 0 && this.state.remittances?.find(x => x.id === this.state.mission.fk_remittance);
        this.state.materials = remittance ? [this.state.allMaterials?.find(x => x.id === remittance.fK_Material)] : this.state.allMaterials;
        this.winwidth = window.innerWidth;
        try {
            this.winwidth = window.viewport.segments[0].width;
        } catch { }
        this.forceUpdate();
    }

    statuses = [
        { id: 0, summary: '---' },
        { id: 1, summary: 'ارسال شده' },
        { id: 2, summary: 'پرداخت شده' }
    ];

    setMissionProp = (kv, whenDone) => {
        this.setState(s => ({ mission: { ...s.mission, ...kv } }), whenDone);
    }

    render() {
        const smallDisplay = this.winwidth < 1400;
        const cols = smallDisplay ? 30 : 45;
        return (
            <Form colCount={cols} rtlEnabled style={{ overflowY: isMobile ? 'scroll' : 'auto', maxHeight: '90vh' }}
            //labelLocation={window.mView ? 'top' : 'left'}
            >
                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='صاحب ماشین' />
                    <SelectBox items={Array.isArray(this.state.truckOwners) ? this.state.truckOwners : []} rtlEnabled
                        value={this.state.truckOwner?.id} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => {
                            let trucks = this.state.allTrucks?.filter(x => x.fK_Owner === e.value);

                            if (trucks?.length === 1)
                                this.state.mission.fk_truck = trucks[0]?.id;

                            this.setState({
                                truckOwner: this.state.truckOwners?.find(x => x.id === e.value),
                                trucks
                            });
                        }}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15} label={{ text: 'پلاک' }}>
                    <Label text='پلاک' />
                    {//this.state.trucks?.length == 1 ?
                        // <CarPlate value={this.state.trucks[0].pelak} readOnly />
                        // :
                        <SelectBox
                            items={Array.isArray(this.state.trucks) ? this.state.trucks : []}
                            rtlEnabled
                            value={this.state.mission.fk_truck} valueExpr='id' displayExpr='pelak'
                            //value={this.state.trucks?.length === 1 ? this.state.trucks[0].id : this.state.mission.fk_truck} valueExpr='id' displayExpr='pelak'
                            dropDownOptions={{ height: '120px' }}
                            onValueChanged={e => this.setMissionProp({ fk_truck: e.value })}
                            itemRender={i => <CarPlate value={i?.pelak} readOnly />}
                        />
                    }
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='راننده' />
                    <SelectBox items={Array.isArray(this.state.drivers) ? this.state.drivers : []} rtlEnabled
                        value={this.state.mission.fk_driver} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => this.setMissionProp({ fk_driver: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='تانکر' />
                    <SelectBox items={Array.isArray(this.state.tankers) ? this.state.tankers : []} rtlEnabled
                        value={this.state.mission.fk_tanker} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => this.setMissionProp({ fk_tanker: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='تاریخ بارگیری' />
                    <TarikhPicker value={this.state.mission.tarikhbargiri} onValueChanged={t => this.setMissionProp({ tarikhbargiri: t })} />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='حواله' />
                    <SelectBox items={Array.isArray(this.state.remittances) ? this.state.remittances : []} rtlEnabled
                        value={this.state.mission.fk_remittance} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => {
                            this.state.materials = this.state.allMaterials?.filter(x => !(e.value > 0) || x.id === this.state.remittances?.find(r => r.id === e.value)?.fK_Material)
                            this.setMissionProp({ fk_remittance: e.value })
                        }}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='متریال' />
                    <SelectBox rtlEnabled // readOnly={this.state.mission.fk_remittance > 0}
                        //items={this.state.materials?.filter(x => !(this.state.mission.fk_remittance > 0) || x.fk_remittance === this.state.mission.fk_remittance)}
                        items={Array.isArray(this.state.materials) ? this.state.materials : []} valueExpr='id' displayExpr='summary'
                        value={this.state.materials?.length === 1 ? this.state.materials[0].id : this.state.mission.fk_material}
                        onValueChanged={e => this.setMissionProp({ fk_material: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='مبدأ' />
                    <SelectBox items={Array.isArray(this.state.transitPoints) ? this.state.transitPoints : []} rtlEnabled
                        value={this.state.mission.fk_frompoint} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => this.setMissionProp({ fk_frompoint: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='مقصد' />
                    <SelectBox items={Array.isArray(this.state.transitPoints) ? this.state.transitPoints : []} rtlEnabled
                        value={this.state.mission.fk_topoint} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => this.setMissionProp({ fk_topoint: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='مشتری' />
                    <SelectBox items={Array.isArray(this.state.customers) ? this.state.customers : []} rtlEnabled
                        value={this.state.mission.fk_tocustomer} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => this.setMissionProp({ fk_tocustomer: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='تناژ' />
                    <NumberBox
                        value={this.state.mission.tonnage}
                        onValueChanged={e => this.setMissionProp({ tonnage: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='کرایه تانکر' />
                    <NumberBox format={{ precision: 0, useCurrencyAccountingStyle: true }}
                        value={this.state.mission.tankerfreight}
                        onValueChanged={e => this.setMissionProp({ tankerfreight: e.value })}
                    >
                        {this.renderPaymentUnitButtons('tankerfreightunit', smallDisplay || isMobile)}
                    </NumberBox>
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='کرایه ماشین' />
                    <NumberBox format={{ precision: 0, useCurrencyAccountingStyle: true }}
                        value={this.state.mission.carfreight}
                        onValueChanged={e => this.setMissionProp({ carfreight: e.value })}
                    >
                        {this.renderPaymentUnitButtons('carfreightunit', smallDisplay || isMobile)}
                    </NumberBox>

                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='قیمت مشتری' />
                    <NumberBox format={{ precision: 0, useCurrencyAccountingStyle: true }}
                        value={this.state.mission.phee}
                        onValueChanged={e => this.setMissionProp({ phee: e.value })}
                    >
                        {this.renderPaymentUnitButtons('pheeunit', smallDisplay || isMobile)}
                    </NumberBox>
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='هزینه بارنامه' />
                    <NumberBox format={{ precision: 0, useCurrencyAccountingStyle: true }}
                        value={this.state.mission.ladingbill}
                        onValueChanged={e => this.setMissionProp({ ladingbill: e.value })}
                    />
                </SimpleItem>

                <SimpleItem colSpan={window.mView ? cols : 15}>
                    <Label text='وضعیت' />
                    <SelectBox items={Array.isArray(this.statuses) ? this.statuses : []} rtlEnabled
                        value={this.state.mission.status} valueExpr='id' displayExpr='summary'
                        onValueChanged={e => this.setMissionProp({ status: e.value })}
                    />
                </SimpleItem>

                {!smallDisplay && <EmptyItem colSpan={cols - 15} />}

                <GroupItem colSpan={window.mView ? cols : Math.floor(cols / 2)}>
                    <EmptyItem />
                    <EmptyItem />
                    <ButtonItem >
                        <ButtonOptions text='ذخیره' icon='save' type='success' width={window.mView ? '100%' : '12rem'}
                            onClick={() => this.props.onSave?.(this.state.mission)}
                        />
                    </ButtonItem>
                    <ButtonItem >
                        <ButtonOptions text='انصراف' icon='close' type='danger' width={window.mView ? '100%' : '12rem'}
                            onClick={() => this.props.OnCancel?.(this.state.mission)}
                        />
                    </ButtonItem>

                </GroupItem>

                <SimpleItem colSpan={window.mView ? cols : cols - Math.floor(cols / 2)}>
                    <PrepareAuxFile table='Mission' rowId={this.state.mission?.id} smallScanButton={smallDisplay} />
                </SimpleItem>

            </Form>
        );
    }
}

export default Missions;